import { createRoot } from "react-dom/client";
import App from "./app/App";
import AppProviders from "./app/AppProviders";
import "./muiLicense";
import { hasAnalyticsConsent } from "./services/cookieService";
import { initializeSentry } from "./services/sentryService";

// Defer Sentry initialization to reduce initial JavaScript execution time
// Initialize Sentry after page load using requestIdleCallback
const initializeSentryDeferred = () => {
	const hasConsent = hasAnalyticsConsent();
	if (hasConsent) {
		const init = () => {
			initializeSentry(true)
				.then(() => {
					console.log("[index][Sentry] - Sentry initialized with analytics consent");
				})
				.catch((error) => {
					console.error("[index][Sentry] - Error initializing Sentry:", error);
				});
		};

		// Use requestIdleCallback for non-critical initialization
		if ("requestIdleCallback" in window) {
			requestIdleCallback(init, { timeout: 2000 });
		} else {
			// Fallback for browsers without requestIdleCallback
			setTimeout(init, 2000);
		}
	} else {
		console.log("[index][Sentry] - Sentry not initialized - analytics consent not granted");
	}
};

// Initialize Sentry after DOM is ready
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initializeSentryDeferred);
} else {
	initializeSentryDeferred();
}

// Register Service Worker for caching
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
	window.addEventListener('load', () => {
		navigator.serviceWorker.register('/sw.js')
			.then((registration) => {
				console.log('[ServiceWorker] Registration successful:', registration.scope);
			})
			.catch((error) => {
				console.log('[ServiceWorker] Registration failed:', error);
			});
	});
}

const container = document.getElementById("root");

if (!container) {
  throw new Error("Root container missing in index.html");
}

const root = createRoot(container);

root.render(
  <AppProviders>
    <App />
  </AppProviders>
);
